// hooks/useCheckAnswer.js
import { useRef, useCallback, useEffect } from "react";
import { fetchData } from "../utils/apiUtils";

export default function useCheckAnswer(query, onAnswered, setShowAnswerBox) {
  const timerRef = useRef(null);

  const stopChecking = useCallback(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  const startChecking = useCallback(() => {
    if (!query) return;
    // avoid double timers
    stopChecking();

    // poll every 2s (tune as needed)
    timerRef.current = setInterval(async () => {
      try {
        const data = await fetchData(query);
        // Expect your endpoint to return a boolean like { answered: true }
        // or { answerOK: true }. Adjust key accordingly.
        const teamAnswered = Boolean(
          data?.answered ?? data?.answerOK ?? data?.isAnswered
        );

        if (teamAnswered) {
          // 1) Close any open modal on this device
          setShowAnswerBox(false);

          // 2) Move to next question (or whatever you want to do)
          if (typeof onAnswered === "function") onAnswered();

          // 3) Stop polling for this question
          stopChecking();
        }
      } catch (e) {
        // Optional: backoff or just keep trying
        // console.error("check failed", e);
      }
    }, 1000);
  }, [query, onAnswered, setShowAnswerBox, stopChecking]);

  // Safety: stop timer if component unmounts
  useEffect(() => stopChecking, [stopChecking]);

  return { startChecking, stopChecking };
}
